module.exports = __webpack_public_path__ + "img/Events.dccf3e6f.svg";